import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, withStyles } from '@material-ui/core/';
import { useTranslation } from 'react-i18next';
import { colors } from '../../../src/Constants/constants';

import Icon from '@material-ui/core/Icon';

export interface IConfirmDeleteModal {
	handleDelete: any;
	isOpen: boolean;
	handleClose: any;
}

export default function ConfirmDeleteModal(props: IConfirmDeleteModal) {
	const { t } = useTranslation();
	const StyledButton = withStyles({
		root: {
			background: colors.main,
			borderRadius: 3,
			border: 0,
			color: 'white',
			height: 36,
			padding: '0 10px',
		},
		label: {
			textTransform: 'capitalize',
		},
	})(Button);

	return (
		<Dialog maxWidth={'md'} open={props.isOpen} onClose={props.handleClose}>
			<DialogTitle id='responsive-dialog-title'>{t('common.form.deleteConfirmationHeader')}</DialogTitle>
			<DialogContent>{t('common.form.deleteConfirmation')}</DialogContent>
			<DialogActions>
				<Button autoFocus onClick={props.handleClose} color='primary'>
					{t('common.cancel')}
				</Button>
				<StyledButton variant='contained' color='primary' endIcon={<Icon>deleteOutlined</Icon>} onClick={props.handleDelete}>
					{t('table.body.deleteTooltip')}
				</StyledButton>
			</DialogActions>
		</Dialog>
	);
}
